define([
    "jquery",
    "underscore",
    "marionette",
    "forms/card/transfer_funds_form",
    "behaviors/form_errors_behavior",
    "backbone.syphon"
], function($, _, Marionette, TransferFundsForm, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui:{
            'submitBtn': '.ct_btn8',
            'accountNoSelect': '#mt4_account_no',
            'form': '#transfer_funds_form',
            'transferable': '#transferable',
            'currencySymbol': '#currency_symbol',
            'amount': '#amount',
            'amountHkd': '#amount_hkd'
        },

        events:{
            'click @ui.submitBtn': 'submit',
            'change @ui.accountNoSelect': function(e){
                this.updateWithdrawable();
            },
            'keyup @ui.amount': function(e){
                // Prevent anything other than 1-9 and . to be written in the amount input.
                $(e.currentTarget).val($(e.currentTarget).val().replace(/[^0-9\.]+/g,''));

                var amount = parseFloat(this.ui.amount.val());

                // The transfer fee is X% of the HKD amount.
                var transferFee = amount * this.transferFeePercent * this.hkdRate;
                // If it's less than 20 (the minimum), apply a transfer fee of 20.
                if(transferFee < 20) transferFee = 20;

                // Display the amount deducted of all the fees (transfer + initial)
                this.ui.amountHkd.val(this.format(amount * this.hkdRate - transferFee - this.initialFee));
            }
        },

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        format: function(value){
            return (Math.round(value*100)*0.01).toFixed(2);
        },

        updateWithdrawable: function(){
            var that = this;
            $.ajax({
                url: '/rest_card/get_transferable_info',
                data:{
                    account_no: this.ui.accountNoSelect.val()
                },
                success: function(data, res){
                    that.ui.transferable.val(data.currency_symbol+' '+data.withdrawable+' (HK$ '+data.withdrawable_hkd+')');
                    that.ui.currencySymbol.html(data.currency_symbol);

                    that.hkdRate = data.exchange_rate;
                    that.transferable = data.withdrawable;

                    // Clear the amounts
                    that.ui.amount.val('');
                    that.ui.amountHkd.val('');
                },
                error: function(data, error){

                }
            })
        },

        initialize: function(){
            this.bindUIElements();

            if(window.info){
                this.transferFeePercent = window.info.transfer_fee_percent;
                this.initialFee = window.info.initial_fee;
                this.hkdRate = window.info.exchange_rate;
                this.transferable = window.info.withdrawable;
            }

            this.form = new TransferFundsForm();
        },

        submit: function(e){
            var that = this;
            if(e) e.preventDefault();

            var formData = Backbone.Syphon.serialize(this);
            this.form.set(formData);

            var errors = this.form.validate();

            if(parseFloat(this.ui.amount.val()) > parseFloat(this.transferable.replace(new RegExp(',', 'g'), ''))){
                errors = _.extend({}, errors, {amount: "You can't transfer more than you have available."});
            }

            if(_.size(errors) < 1){
                this.form.validateWithServer({
                    type: 'POST',
                    success: function(model, res){
                        that.ui.form.submit();
                    },
                    error: function(model, error){
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                });
            }else{
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});